import { boxOfficePoints } from '@/mocks/home';

const bars = [
  { label: '话题热度', value: 78, role: 'accent' },
  { label: '同期竞争力', value: 42, role: 'primary' },
  { label: '口碑延续', value: 28, role: 'secondary' },
];

export default function BoxOffice() {
  return (
    <section id="boxoffice" className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
          <div className="reveal">
            <span className="text-primary-600 font-label text-sm tracking-wide">当年票房</span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              热度不低，结果平平
            </h2>
            <p className="mt-3 text-foreground-600 text-sm md:text-base leading-relaxed">
              在 2011 年那波 3D 情色片热潮里，这部改编拿到了不错的起步话题，却没能把它兑现成持续的市场表现。
            </p>

            <ul className="mt-6 space-y-4">
              {boxOfficePoints.map((point, index) => (
                <li key={point} className="flex gap-3">
                  <span className="mt-0.5 w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full bg-background-100 text-primary-600 text-[11px] font-label">
                    {index + 1}
                  </span>
                  <p className="text-foreground-700 text-sm md:text-base leading-relaxed">{point}</p>
                </li>
              ))}
            </ul>
          </div>

          <div className="reveal">
            <div className="rounded-lg overflow-hidden h-[200px] md:h-[240px] mb-5">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20composition%20of%20movie%20tickets%20and%20warm%20bar%20chart%20shapes%20in%20peach%20and%20amber%20gradients%2C%20soft%20studio%20lighting%2C%20grainy%20analog%20texture%2C%20minimal%20artistic%20still%20life%2C%20high%20detail%2C%20no%20text&width=1000&height=750&seq=peach-boxoffice-01&orientation=landscape"
                alt="以电影票与图表构成的抽象画面，呼应票房盘点主题"
                className="w-full h-full object-cover object-top"
              />
            </div>

            <div className="bg-background-100/70 border border-background-200/80 rounded-lg p-6">
              <p className="font-label text-xs md:text-sm text-foreground-600">
                相对表现示意（非精确数据）
              </p>
              <div className="mt-5 space-y-5">
                {bars.map((bar) => (
                  <div key={bar.label}>
                    <div className="flex items-center justify-between text-xs md:text-sm text-foreground-700 font-label">
                      <span>{bar.label}</span>
                      <span>{bar.value}%</span>
                    </div>
                    <div className="mt-2 h-2 rounded-full bg-background-200 overflow-hidden">
                      <div
                        className={`h-full rounded-full ${
                          bar.role === 'accent'
                            ? 'bg-accent-500'
                            : bar.role === 'primary'
                              ? 'bg-primary-500'
                              : 'bg-secondary-500'
                        }`}
                        style={{ width: `${bar.value}%` }}
                      />
                    </div>
                  </div>
                ))}
              </div>
              <p className="mt-5 text-foreground-500 text-[11px] md:text-xs leading-relaxed">
                此图仅用于直观呈现“话题高、转化低、长尾弱”的整体印象，不代表具体票房数字。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}